<template>
  <div class="txt-page">
    <div class="tips">
      <!-- <div class="icon">
        <img src="/img/index/tip.png" />
      </div> -->
      <div class="content">
        <p>
          格式A：号码，号码，号码
          格式B：号码=金额，号码=金额，号码=金额(逗号也可以用空格代表)
        </p>
        <p>
          <div>
            说明:由于各会员使用的《txt文件)的格式不一样，如果不符合网站上要求的格式，有可能导入到网站(没有下注之前)的号码内容和自己(txt文件
          </div>
          <div>
            里号码内容不一致，操作时请认真检查，如果出现内容不一致，请不要下注
          </div>
        </p>
      </div>
    </div>
    <div class="create-box">
      <!-- <h1 class="title default_border bc_default">号码生成区</h1> -->
      <div
        v-if="htmlData !== ''"
        class="create-content"
        v-html="htmlData"
      ></div>
      <div
        class="create-content"
        style="
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        v-else
      >
        <div class="noData"></div>
      </div>
    </div>
    <div class="bottom-tool">
      <input type="file" ref="file" @change="uploadfile($event)" />

      <div class="statistics">
        <span class="bold">笔数：</span>
        <span class="bold">{{ totalNum }}</span>
        <span class="bold">金额：</span>
        <span class="bold">{{ totalMoney }}</span>
      </div>
      <div class="quick-money">
        <span class="bold active-text">下注金额：</span>
        <input
          class="input"
          type="text"
          oninput="value=value.replace(/[^\d | ^.]/g,'').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')"
          maxlength="5"
          v-model="money"
          :disabled="disabledInputMoney"
        />
      </div>
      <div class="btn-group">
        <input class="btn primary" type="button" value="提交" @click="bet()" />
        <!-- <input type="button" value="重置" @click="reset()" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numberStr: "",
      htmlData: "",
      disabledInputMoney: false,
      totalNum: "",
      totalMoney: "",
      money: "",
    };
  },
  props: ["isClose"],
  watch: {
    money(newVal) {
      if (newVal !== "" && this.totalNum !== "") {
        this.totalMoney = newVal * this.totalNum;
      }
    },
    totalNum(newVal) {
      if (newVal !== "" && this.money !== "") {
        this.totalMoney = newVal * this.money;
      }
    },
  },
  methods: {
    uploadfile(e) {
      let _this = this;
      let numberList = [];
      let typeList = [];
      let file = e.target.files[0];
      //       指定上传文件为txt格式
      if (file.name.split(".")[file.name.split(".").length - 1] != "txt") {
        document.activeElement.blur();
        this.$alert("请上传格式为TXT的文件。", "提示", {
          callback: () => {
            e.target.value = null;
          },
        });
      } else {
        let reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = function (evt) {
          let data = evt.target.result;
          data = data.replace(/\n/g, " ");
          data = data.replace(/\r\n/g, " ");
          data = data.replace(/,/g, " ");
          data = data.replace(/，/g, " ");
          data = data.replace(/\s+/g, " ");
          _this.numberStr = data;
          let dataAry = data.split(" ");
          let htmldata = [];
          let hasMoney = false;
          htmldata.push("<table cellspacing='0' cellpadding='0'><thead>");
          if (data.indexOf("=") != -1) {
            for (let i = 0; i < 12; i++) {
              if (i % 2 == 0) htmldata.push("<td>号码</td>");
              else htmldata.push("<td>金额</td>");
            }
            hasMoney = true;
          } else {
            for (let i = 0; i < 12; i++) {
              htmldata.push("<td>号码</td>");
            }
          }

          htmldata.push("</thead><tbody>");
          let i = 0,
            totalmoney = 0;
          for (let n = 0; n < dataAry.length; n++) {
            let number = dataAry[n].split("=")[0];
            let money = 0;
            if (dataAry[n].split("=").length >= 2) {
              money = dataAry[n].split("=")[1];
            }
            let type = _this.$getDWTypeByName(number);
            // console.log(number, "--" ,type)
            if (type == 0) continue;
            // if (type == 0 || typeList.indexOf(type) != -1) continue;

            if (i == 0) {
              htmldata.push("<tr>");
            } else if (hasMoney) {
              if (i % 6 == 0) {
                htmldata.push("</tr><tr>");
              }
            } else {
              if (i % 12 == 0) {
                htmldata.push("</tr><tr>");
              }
            }
            htmldata.push("<td>" + number + "</td>");
            if (hasMoney) money = money == 0 ? 1 : money;
            if (hasMoney)
              htmldata.push("<td>" + (money == 0 ? "--" : money) + "</td>");
            i++;
            numberList.push(type + ":" + money);
            typeList.push(type);
            totalmoney = _this.$floatAdd(totalmoney, parseFloat(money));
          }
          htmldata.push("</tr></tbody></table>");
          _this.htmlData = htmldata.join("");
          _this.totalNum = i;
          _this.totalMoney = totalmoney;
          if (totalmoney > 0) {
            _this.disabledInputMoney = true;
          } else {
            _this.disabledInputMoney = false;
          }
        };
      }
    },
    async bet() {
      if (this.isClose == 0) {
        let money = this.money;
        if (money.length == 0 && parseFloat(money) <= 0) {
          return;
        }

        if (this.htmlData.length == 0) {
          return;
        }
        if (this.totalNum > 10000) {
          document.activeElement.blur();
          this.$alert("单笔最大只能下注10000注", "提示");
          return;
        }
        let str = this.numberStr.split(" ");
        let newArr = [];
        if (str[0].split("=")[1]) {
          str.forEach((item) => {
            item = item.replace("=", ":");
            if (
              item.split(":")[0].substr(item.split(":")[0].length - 1, 1) ==
                "X" &&
              item.split(":")[0].replace(/\D/g, "").length >= 2
            ) {
              item = `${item.split(":")[0].substr(0, 4)}:${item.split(":")[1]}`;
            }
            if (item != "") {
              let flag = false;
              newArr.forEach((newItem, index) => {
                if (newItem.split(":")[0] == item.split(":")[0]) {
                  flag = true;
                  newArr[index] = `${newItem.split(":")[0]}:${
                    newItem.split(":")[1] * 1 + item.split(":")[1] * 1
                  }`;
                }
              });
              if (!flag) {
                newArr.push(item);
              }
            }
          });
        } else {
          str.forEach((item) => {
            if (
              item.substr(item.length - 1, 1) == "X" &&
              item.replace(/\D/g, "").length >= 2
            ) {
              item = item.substr(0, 4);
            }
            if (item != "") {
              newArr.push(`${item}:${money}`);
            }
          });
        }
        let data = {
          access_token: this.$store.state.userInfo.access_token,
          uid: this.$store.state.userInfo.uid,
          game_code: this.$store.state.gameInfo[0].code,
          key: new Date().getTime(),
          play_type: "daoru",
          total_money: this.totalMoney,
          bet_num: this.totalNum,
          bet_str: newArr.join(","),
          bet_log: "游戏日志",
          bet_qihao: this.$store.state.gameInfo[0].nextQihao,
        };
        let result = await this.$http.postAxiosMethod("/user/bet2", data);
        if (result.code == 0) {
          this.$message({
            iconClass: "fa fa-check-circle",
            customClass: "bet_message",
            type: "success",
            duration: 3000,
            message: "下注成功！",
          });
          this.reset();
          setTimeout(() => {
            this.$BUS.$emit("bet");
          }, 500);
        }
      } else {
        document.activeElement.blur();
        this.$alert("已封盘", "提示");
      }
    },
    reset() {
      this.numberStr = "";
      this.htmlData = "";
      this.totalNum = "";
      this.totalMoney = "";
      this.money = "";
      this.$refs.file.value = null;
    },
  },
};
</script>

<style lang="scss">
.txt-page {
  table {
    width: 100%;
    font-size: 12px;
    border: 1px solid var(--primary-table-border-color);
    tr {
      td {
        border-right: 1px solid var(--primary-table-border-color);
        border-bottom: 1px solid var(--primary-table-border-color);
      }
      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
    thead {
      tr {
        td {
          border-right: 1px solid var(--primary-table-border-color);
          border-bottom: 1px solid var(--primary-table-border-color) !important;
          border-top: none;
          &:last-child {
            border-right: none;
          }
        }
      }
    }

    td {
      text-align: center;
      padding: 5px;
      // &:nth-child(1) {
      //   border-left: none;
      // }
      // &:nth-child(12n) {
      //   border-right: none;
      // }
    }
  }
}
</style>

<style lang="scss" scoped>
.txt-page {
  font-size: 13px;
  background: #fff;
  border: 1px solid var(--primary-table-border-color);
  .title {
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    background: var(--primary-table-header-color);
  }
  .tips {
    display: flex;
    font-size: 12px;
    padding: 10px 15px;
    .icon {
      margin-right: 18px;
      width: 58px;
      height: 58px;
      img {
        width: 100%;
      }
    }
    .content {
      p:not(:nth-child(1)) {
        margin-top: 10px;
      }
    }
  }
  .create-box {
    .title {
      height: 32px;
      background-color: var(--new-bg-white);
      font-size: 14px;
      text-align: center;
      line-height: 32px;
      border: 1px solid #bad4e8;
      border-left: none !important;
      border-right: none !important;
    }
    .create-content {
      height: 295px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .bottom-tool {
    display: flex;
    align-items: center;
    height: 45px;
    background-color: var(--new-bg-table-header-main);
    border-top: 1px solid var(--primary-table-border-color);
    border-left: none !important;
    border-bottom: none !important;
    border-right: none !important;
    font-size: 12px;
    input {
      font-size: 13px;
    }
    input[type="file"] {
      width: 180px;
      margin-left: 45px;
    }
    .quick-money {
      margin-left: 30px;
      input[type="text"] {
        width: 98px;
        height: 22px;
        background: var(--new-bg-white);
        border: 1px solid var(--new-border);
      }
    }
    .btn-group {
      margin-left: 20px;
      input[type="button"] {
        // width: 60px;
        // height: 20px;
        // line-height: 20px;
        // border-radius: 2px;
        // color: #fff;
        // &:nth-child(1) {
        //   margin-right: 15px;
        //   background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
        // }
        // &:nth-child(2) {
        //   background: linear-gradient(90deg, #01d5c1, #00b5b8, #0096ac);
        // }
      }
    }
    .statistics {
      margin-left: 30px;
      & > span {
        margin-right: 15px;
        display: inline-block;
      }
    }
  }
}
</style>
